import { StarterKit } from '@tiptap/starter-kit';
import { Bold } from '@tiptap/extension-bold';
import { Italic } from '@tiptap/extension-italic';
import { Subscript } from '@tiptap/extension-subscript';
import { Superscript } from '@tiptap/extension-superscript';
import { TextAlign } from '@tiptap/extension-text-align';
import { TableCell, TableRow } from '@tiptap/extension-table';
import { TableImproved } from 'mui-tiptap';

const BoldAsBTag = Bold.extend({
    renderHTML({ HTMLAttributes }) {
        return ['b', HTMLAttributes, 0];
    },
});

const ItalicAsITag = Italic.extend({
    renderHTML({ HTMLAttributes }) {
        return ['i', HTMLAttributes, 0];
    },
});

const CellOnlyTableRow = TableRow.extend({
    content: 'tableCell*',
});

export const generalInfoEditorExtensions = [
    StarterKit.configure({
        bold: false,
        italic: false,
        code: false,
        codeBlock: false,
        link: false,
    }),
    BoldAsBTag,
    ItalicAsITag,
    Subscript,
    Superscript,
    TextAlign.configure({ types: ['heading', 'paragraph'] }),
    TableImproved.configure({ resizable: false }),
    CellOnlyTableRow,
    TableCell,
];
